/** VATເພີ່ມເທິງຍອດຫຼັງຫຼຸດ (exclusive) — ໃຊ້ທັງ server checkout ແລະ client ສະແດງຍອດ */
export function roundMoneyPos(n: number): number {
  return Math.round(n * 100) / 100;
}

export function applyExclusivePosTax(
  netAfterDiscount: number,
  taxPercent: number,
): {
  taxTotal: number;
  grandTotal: number;
  taxPercentApplied: number;
} {
  const net = roundMoneyPos(Math.max(0, netAfterDiscount));
  const p = Math.min(Math.max(0, taxPercent), 100);
  if (p <= 0) {
    return { taxTotal: 0, grandTotal: net, taxPercentApplied: 0 };
  }
  const taxTotal = roundMoneyPos((net * p) / 100);
  return {
    taxTotal,
    grandTotal: roundMoneyPos(net + taxTotal),
    taxPercentApplied: p,
  };
}

/** ສະແດງເລກ % ບນໃບຮັບ / ໃບກຳກັບ */
export function formatPosTaxPercentLabel(percent: number): string {
  if (!Number.isFinite(percent) || percent <= 0) return "";
  const rounded = roundMoneyPos(percent);
  if (Number.isInteger(rounded)) return String(rounded);
  return rounded.toFixed(2).replace(/\.?0+$/, "");
}

/**
 * VAT ສຳລັບສະແດງໃບຮັບ — ໃຊ້ຄ່າບັນທຶກໃນບິນ ຫຼືຄິດຈາກຍອດກ່ອນVAT+VAT (ບິນເກົ່າ / ຖ້າບໍ່ມີ tax_percent)
 */
export function effectivePosTaxPercentDisplay(
  netBeforeTax: number,
  taxTotal: number,
  storedPercent: number,
): number {
  const stored = roundMoneyPos(Math.max(0, storedPercent));
  if (stored > 0.0001) return Math.min(stored, 100);
  const net = roundMoneyPos(Math.max(0, netBeforeTax));
  const tax = roundMoneyPos(Math.max(0, taxTotal));
  if (net <= 0 || tax <= 0.0001) return 0;
  const implied = roundMoneyPos((tax / net) * 100);
  return Math.min(implied, 100);
}
